// src/js/main/global.js

import { initializeFocusHandler } from '../utils/focusHandler.js';
import { updateDynamicBreakpoint, equalizePanelHeaderHeights } from '../utils/helpers.js';
import { initializeCookieBanner } from '../components/cookieBanner.js';
import { initializeMobileNavigation } from '../components/mobileNavigation.js';
import { initializeAccordions } from '../components/accordion.js';
import { initializeGenericModals } from '../components/genericModal.js'; // NY RAD
import { initializeHoverTooltips } from '../components/hoverTooltip.js'; // NY IMPORT


// Kör all global logik som ska finnas på varje sida.
document.addEventListener('DOMContentLoaded', () => {
    // Grundläggande hjälpfunktioner
    initializeFocusHandler();
    updateDynamicBreakpoint();
    equalizePanelHeaderHeights();

    // Initiera UI-komponenter
    initializeCookieBanner();
    initializeMobileNavigation();
    initializeAccordions();
    initializeGenericModals();
    initializeHoverTooltips();

    // Sätt upp en "debounced" event listener för resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            updateDynamicBreakpoint();
            equalizePanelHeaderHeights();
        }, 150);
    });
});